<template>
    <button type="button" class="d-none" data-toggle="modal" data-target=".moveFolderModals" id="moveFolderBtn"> </button>
    <div class="modal fade moveFolderModals move_mdrivefolder" id="moveFolderModalId" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Move "{{$store.state.fileNameParam}}"</h5>
                </div>
                <div class="modal-body">                       
                    <div class="d-flex justify-content-between">
                        <nav aria-label="breadcrumb" v-if="breadcrumbItems.length > 0">
                            <ol class="breadcrumb">
                                    <li 
                                    class="breadcrumb-item active" 
                                    v-if="breadcrumbItems.length > 0"
                                    @click="detailHomeFolder()"
                                    >
                                    <a href="javascript:;" class="cursor-pointer">Home</a>
                                </li>
                                <template v-for="(item, index) in breadcrumbItems" :key="index">
                                    <li 
                                    class="breadcrumb-item active" 
                                    v-if="item !== ''"
                                    @click="detailSubFolder(index)"
                                    >
                                    <a href="javascript:;" class="cursor-pointer">{{ item }}</a>
                                    </li>
                                </template>
                            </ol>
                        </nav>
                    </div>
                    <div class="form-group m-0">
                            <ul class="list-group list-group-flush" v-if="$store.state.isSubFolder === 1">
                                <li 
                                    class="list-group-item d-flex align-items-center justify-content-between folder-item"  v-if="isHomeFolder == 2"
                                >
                                    <!-- Left: Folder icon + name -->
                                    <div class="d-flex align-items-center justify-content-between">
                                        <div class="icon-small mr-2">
                                            <MyDriveSvg />
                                        </div>
                                        <span class="folder-name">My Drive</span>
                                    </div>
                                    <div class="folder-actions_main_right d-flex">
                                        <div class="folder-actions d-flex align-items-center mx-2" >
                                            <button class="btn btn-link btn-sm text-primary p-0 me-4 mofolder" v-if="isMoveDirectFolder === 1"  @click="MoveToDirectFolder($store.state.user_id+'/')">Move</button>
                                            <button class="btn btn-link btn-sm text-primary p-0 me-4 mofolder disableMoveBtn" v-else >Move</button>
                                        </div>
                                    </div>
                                </li>
                                <li 
                                    class="list-group-item d-flex align-items-center justify-content-between folder-item" 
                                    v-for="(item) in $store.state.folderList" 
                                    :key="'main-' + item._id"
                                    :class="sameFolderName == item.fullKey ? 'disableLiCls' : ''"
                                >
                                    <!-- Left: Folder icon + name -->
                                    <div class="d-flex align-items-center justify-content-between" >
                                        <div class="icon-small mr-2" v-if="item.isFileShared == 1">
                                            <FolderSharedSvg />
                                        </div>
                                        <div class="icon-small mr-2" v-else>
                                            <FolderSvg />
                                        </div>
                                        <span class="folder-name">{{ item.name }}</span>
                                    </div>
                                    <div class="folder-actions_main_right d-flex" v-if="sameFolderName != item.fullKey">
                                        <div class="folder-actions d-flex align-items-center mx-2" v-if="trimmedPath != item.fullKey">
                                            <button class="btn btn-link btn-sm text-primary p-0 me-4 mofolder" v-if="isMoveDirectFolder === 1" @click="MoveToDirectFolder(item.fullKey)">Move</button>
                                            <button class="btn btn-link btn-sm text-primary p-0 me-4 mofolder disableMoveBtn" v-else >Move</button>
                                        </div>
                                        <div class="folder-actions d-flex align-items-center" @click="detailFolder(item.key, '', item.fullKey)">
                                            <svg class=" a-s-fa-Ha-pa c-qd" width="24px" height="24px" viewBox="0 0 24 24" focusable="false" fill="currentColor"><path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"></path></svg>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                            <ul class="list-group list-group-flush" v-if="folderLoader == 3">
                                <li v-if="$store.state.folderSubList.length == 0"   >
                                    <div class="text-center">
                                        <ComponentHomeNoData />
                                    </div>
                                </li> 
                            </ul>
                            <ul class="list-group list-group-flush" v-if="$store.state.isSubFolder === 2">
                                <li 
                                    class="list-group-item d-flex align-items-center justify-content-between folder-item" 
                                    v-for="(item) in $store.state.folderSubList" 
                                    :key="'sub-' + item._id"
                                    :class="sameFolderName == item.fullKey ? 'disableLiCls' : ''"
                                >
                                    <!-- Left: Folder icon + name -->
                                    <div class="d-flex align-items-center">
                                        <div class="icon-small mr-2" v-if="item.isFileShared == 1">
                                            <FolderSharedSvg />
                                        </div>
                                        <div class="icon-small mr-2" v-else>
                                            <FolderSvg />
                                        </div>
                                        <span class="folder-name">{{ item.name }}</span>
                                    </div>
                                    <div class="folder-actions_main_right d-flex" v-if="sameFolderName != item.fullKey">
                                        <div class="folder-actions d-flex align-items-center"  v-if="trimmedPath != item.fullKey">
                                            <button class="btn btn-link btn-sm text-primary p-0 me-4 mofolder" v-if="isMoveDirectFolder === 1" @click="MoveToDirectFolder(item.fullKey)">Move</button>
                                            <button class="btn btn-link btn-sm text-primary p-0 me-4 mofolder disableMoveBtn" v-else >Move</button>
                                        </div>
                                        <div v-if="trimmedPath == item.fullKey">
                                        </div>
                                        <div class="folder-actions d-flex align-items-center" @click="detailFolder(item.key, folderPath, item.fullKey)" v-else>
                                            <svg class=" a-s-fa-Ha-pa c-qd" width="24px" height="24px" viewBox="0 0 24 24" focusable="false" fill="currentColor"><path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"></path></svg>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                    </div>
                </div>
                <div class="modal-footer">
                <!-- {{ item.fullKey }} -->
                    <button type="button" class="btn btn-secondary cancel" data-dismiss="modal" id="closeMoveFolderPop">Cancel</button>
                    <button type="submit" class="btn btn-primary mgbtn_submit" :class="{ disableMoveBtn: isMoveFolder === 1 }" v-on:click="MoveToFolder" v-if="formLoader === 1">Move</button>
                    <button type="button" class="btn btn-primary" v-else><span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        Loading...</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import {
        startLoader,
        finishLoader
} from '../../utils/helper.js'
import 
    { post } 
from '../../utils/api.js'
import FolderSvg from '@/components/Widgets/Icon/Folder.vue'
import MyDriveSvg from '@/components/Widgets/Icon/MyDrive.vue'
import FolderSharedSvg from '@/components/Widgets/Icon/FolderShared.vue'
import ComponentHomeNoData from '@/components/Widgets/Icon/ComponentHomeNoData.vue'
export default {
    name: 'MoveFolderData',
    data() {
        return {
            folderPath: '',
            formLoader: 1,
            folderLoader: 1,
            fullLatestKey: 1,
            isHomeFolder: 1,
            isMoveFolder: 1,
            isMoveDirectFolder: 1,
            sameFolderName: null,
            trimmedPath: null,
        }
    },
    components: {
            FolderSvg,
            MyDriveSvg,
            FolderSharedSvg,
            ComponentHomeNoData
        },
        computed: {
            breadcrumbItems() {
                return this.folderPath.split('/').filter(item => item !== '');
            }
    },  
    methods: {
        startLoader,
        finishLoader,
        async loadFolderList(isMain) {
            this.folderLoader = 2;
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.$store.state.user.accessToken;
            let _post = {}
            if (isMain === 1) {
                _post = {
                    // limit: 8,
                }
            }else{
                _post = {
                    folderName: this.folderPath,
                }
            }
            this.startLoader();
            const resp = await post('files/list-folders', _post)
            if (resp.status == 200 && resp.data.status == 'success') {
                if (isMain === 1) {
                    this.$store.state.folderList = resp.data.data.folders;
                }else{
                    this.$store.state.folderSubList = resp.data.data.folders;
                    this.folderLoader = 3;
                }
            } else {
                this.errorMessage = resp.data.message;
            }
            this.finishLoader();
        },
        slashCount(fullKey) {
            return (fullKey.match(/\//g) || []).length;
        },
        async openMoveFolder(id, name, fullKey, user_id) {
            this.$store.state.fileNameParam = name;
            this.$store.state.fileNameIdParam = id;
            this.$store.state.user_id = user_id;
            this.$store.state.fullOldKey = fullKey;
            this.$store.state.isSubFolder = 1;
            this.folderPath = '';
            if (this.slashCount(fullKey) > 2) {
                this.isHomeFolder = 2
            } else {
                this.isHomeFolder = 1;
            }
            this.sameFolderName = fullKey;
            this.trimmedPath = fullKey.replace(/[^/]+\/$/, '');
            this.folderLoader = 1;
            this.fullLatestKey = 1;
            await this.loadFolderList(1);
            document.getElementById('moveFolderBtn').click();
        },
        async detailHomeFolder() {
            this.isMoveFolder = 1;
            this.folderPath = '';
            this.$store.state.isSubFolder = 1;
            await this.loadFolderList(1);
        },
        async detailFolder(key, folderPath, fullKey) {

            this.isMoveFolder = 2;
            this.fullLatestKey = fullKey;
            
            if(folderPath == '') {
                this.folderPath = key;
            } else {
                this.folderPath = folderPath+'/'+key;
            }
            this.$store.state.isSubFolder = 2;
            await this.loadFolderList(2);
        },
        detailSubFolder(index) {
            const newPath = this.breadcrumbItems.slice(0, index + 1).join('/');
            this.folderPath = newPath; // or emit it / update store etc.
            console.log('Updated path:', newPath);
            this.detailFolder(newPath, '')
            
            // Optional: trigger loading or routing logic here
            // this.loadFolderContent(newPath)
        },
        async MoveToDirectFolder(newPath) {
            this.isMoveDirectFolder = 2;
            let _post = {}
            _post = {
                oldPath: this.$store.state.fullOldKey,
                newPath: newPath+''+this.$store.state.fileNameParam+'/',
            }
            this.startLoader();
            const resp = await post('files/move-folder', _post)
            if (resp.status == 200 && resp.data.status == 'success') {
                this.$store.state.home.reLoadFoldercomponent = Math.random();
                // this.$store.state.home.reLoadFilecomponent = Math.random();
                document.getElementById('closeMoveFolderPop').click();
            } else {
                this.errorMessage = resp.data.message;
            }
            this.isMoveDirectFolder = 1;
            this.finishLoader();
        },
        async MoveToFolder() {
            let newPath = '';
            if(this.fullLatestKey == 1){
                newPath = this.$store.state.fileNameIdParam+'/'+this.$store.state.fileNameParam+'/';
            }else{
                newPath = this.fullLatestKey+''+this.$store.state.fileNameParam+'/';
            }

            let _post = {}
            _post = {
                oldPath: this.$store.state.fullOldKey,
                newPath: newPath,
            }
            this.startLoader();
            const resp = await post('files/move-folder', _post)
            if (resp.status == 200 && resp.data.status == 'success') {
                this.$store.state.home.reLoadFoldercomponent = Math.random();
                // this.$store.state.home.reLoadFilecomponent = Math.random();
                document.getElementById('closeMoveFolderPop').click();
            } else {
                this.errorMessage = resp.data.message;
            }
            this.finishLoader();
        },
    },
}
</script>